import FileSaver from 'file-saver';

const saveFile = (fileData, fileName) => FileSaver.saveAs(fileData, fileName);

export default saveFile;
